import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconUpArrowSolid = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z" }) }));
const Memo = memo(SvgIconUpArrowSolid);
export default Memo;
//# sourceMappingURL=IconUpArrowSolid.js.map